import script from "./AddPanelModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddPanelModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddPanelModal.vue?vue&type=style&index=0&id=ed926054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed926054"]])

export default __exports__